goog.provide("shadow.js.shim.module$src$svg$controls$media_player_call$media_play_svg$default");
shadow.js.shim.module$src$svg$controls$media_player_call$media_play_svg$default = shadow.js.shim.module$src$svg$controls$media_player_call$media_play_svg.default;
